import { createNamespacedStorage } from "./namespaced-storage";
/**
 * localStorage persistence for DataTable page size.
 *
 * Keyed by the table's `tableId`, so each table remembers its own page size
 * across reloads, navigation and logout/login (per-browser/per-device) — the
 * URL param only carries in-session deviations and is lost on a fresh login.
 */ function validatePageSize(stored) {
    return typeof stored === "number" && Number.isInteger(stored) && stored > 0 ? stored : null;
}
const pageSizeStorage = createNamespacedStorage("pageSize", validatePageSize);
export const pageSizeStorageKey = pageSizeStorage.storageKey;
export const readPersistedPageSize = pageSizeStorage.read;
export const writePersistedPageSize = pageSizeStorage.write;

//# sourceMappingURL=page-size-storage.js.map